var _rect, _rect2, _path, _rect3, _rect4, _path2, _path3, _path4, _rect5, _path5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _circle, _path83, _path84, _path85, _path86, _path87, _circle2, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _circle3, _circle4, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _rect14, _rect15, _path118;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFitnessTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2100 1600",
    id: "FitnessTeacher",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1565.82,
    height: 1044.6,
    x: 292.37,
    y: 218.73,
    rx: 126.21,
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#c7c7c7",
    className: "colorc7c7c7 svgShape"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1576.04,
    height: 1017.2,
    x: 236.28,
    y: 191.83,
    fill: "#4a5fa6",
    rx: 138.46,
    className: "color4a7ea6 svgShape"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 905.02,
    height: 1463.87,
    x: 571.79,
    y: -31.5,
    fill: "#b3c4ff",
    rx: 82.37,
    transform: "rotate(90 1024.305 700.435)",
    className: "colorb3e7ff svgShape"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4a5fa6",
    d: "M955.36 1209.03h137.9v117.85h-137.9z",
    className: "color4a7ea6 svgShape"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 811.21,
    height: 623.54,
    x: 816.36,
    y: 477.15,
    fill: "#809dff",
    rx: 21,
    className: "color80d7ff svgShape"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 588.54,
    height: 776.21,
    x: 927.7,
    y: 400.81,
    fill: "#e0e7ff",
    rx: 3.5,
    transform: "rotate(90 1221.965 788.915)",
    className: "colore0f6ff svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3c4ff",
    d: "M1714 1193.38v-143a11.11 11.11 0 0 0-11.12-11.11h-278.3a11.1 11.1 0 0 0-11.11 11.11V1250a11.12 11.12 0 0 1-11.12 11.12h-225.78a11.11 11.11 0 0 0-11.12 11.11v105.23a11.12 11.12 0 0 0 11.12 11.12h774.33a11.12 11.12 0 0 0 11.12-11.12v-161.85a11.12 11.12 0 0 0-11.12-11.12h-225.78a11.11 11.11 0 0 1-11.12-11.11Z",
    className: "colorb3e7ff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M1714 1193.38v-143a11.11 11.11 0 0 0-11.12-11.11h-278.3a11.1 11.1 0 0 0-11.11 11.11V1250a11.12 11.12 0 0 1-11.12 11.12h-225.78a11.11 11.11 0 0 0-11.12 11.11v105.23a11.12 11.12 0 0 0 11.12 11.12h774.33a11.12 11.12 0 0 0 11.12-11.12v-161.85a11.12 11.12 0 0 0-11.12-11.12h-225.78a11.11 11.11 0 0 1-11.12-11.11Z",
    className: "colore6e6e6 svgShape"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3c4ff",
    d: "m1563.35 1111.75-7.75 6.83-4.64-5.36 12.61-10.65h7.65v38.67h-7.87ZM1821.74 1272.44l15-13.49a27.06 27.06 0 0 0 2.29-2.35 4.46 4.46 0 0 0 1.15-3 3.75 3.75 0 0 0-1.42-3.09 5.21 5.21 0 0 0-3.33-1.12 4.56 4.56 0 0 0-3.58 1.42 5.71 5.71 0 0 0-1.45 3.49l-8.19-.6a13.27 13.27 0 0 1 1.26-5.21 10.8 10.8 0 0 1 2.89-3.69 12.19 12.19 0 0 1 4.23-2.21 18.14 18.14 0 0 1 5.27-.74 16 16 0 0 1 4.92.74 11.51 11.51 0 0 1 4 2.18 10 10 0 0 1 2.64 3.64 12.51 12.51 0 0 1 1 5.08 14 14 0 0 1-.38 3.36 11.42 11.42 0 0 1-1.07 2.73 12 12 0 0 1-1.61 2.26 25.66 25.66 0 0 1-2 2l-11.74 10.11h17.15v7.21h-27ZM1287.83 1306.94h2.67a15 15 0 0 0 2.24-.16 6.42 6.42 0 0 0 2-.63 3.64 3.64 0 0 0 1.44-1.31 4 4 0 0 0 .55-2.21 3.6 3.6 0 0 0-1.39-2.9 5.23 5.23 0 0 0-3.42-1.14 4.73 4.73 0 0 0-4.8 3.6l-9-1.86a12.32 12.32 0 0 1 2-4.28 10.76 10.76 0 0 1 3.12-2.87 13.81 13.81 0 0 1 4-1.61 20.19 20.19 0 0 1 4.67-.52 19.17 19.17 0 0 1 4.94.63 12.12 12.12 0 0 1 4.18 2 10 10 0 0 1 2.87 3.36 10.19 10.19 0 0 1 1.06 4.81 9 9 0 0 1-1.69 5.51 7.74 7.74 0 0 1-4.91 3v.17a7.5 7.5 0 0 1 3.08 1 8.31 8.31 0 0 1 2.27 2 8.86 8.86 0 0 1 1.42 2.73 10.38 10.38 0 0 1 .49 3.22 11.08 11.08 0 0 1-1.12 5.08 10.55 10.55 0 0 1-3 3.63 12.85 12.85 0 0 1-4.42 2.16 20 20 0 0 1-5.38.71 16.12 16.12 0 0 1-8.93-2.41 11.67 11.67 0 0 1-4.94-7.59l8.63-2a5.87 5.87 0 0 0 1.77 3.28 5.77 5.77 0 0 0 4 1.2 5.11 5.11 0 0 0 4-1.39 5.06 5.06 0 0 0 1.29-3.58 3.76 3.76 0 0 0-2.46-3.88 8.07 8.07 0 0 0-2.46-.52c-.91 0-1.82-.08-2.73-.08h-1.91Z",
    className: "colorb3e7ff svgShape"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 764.83,
    height: 67.3,
    x: 641.89,
    y: 1326.89,
    fill: "#4a5fa6",
    rx: 14.55,
    className: "color4a7ea6 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#cccccc",
    d: "M955.36 1209.03h137.9v117.85h-137.9z",
    className: "colorcccccc svgShape"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 315.08,
    height: 87.51,
    x: 347.85,
    y: 326.65,
    fill: "#e0e7ff",
    rx: 20.58,
    className: "colore0f6ff svgShape"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 957.58,
    height: 87.51,
    x: 743.17,
    y: 326.65,
    fill: "#e0e7ff",
    rx: 20.58,
    className: "colore0f6ff svgShape"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 323.38,
    height: 31.26,
    x: 373.92,
    y: 463.27,
    fill: "#e0e7ff",
    rx: 15.32,
    className: "colore0f6ff svgShape"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 323.38,
    height: 31.26,
    x: 373.92,
    y: 533.27,
    fill: "#e0e7ff",
    rx: 15.32,
    className: "colore0f6ff svgShape"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 323.38,
    height: 31.26,
    x: 373.92,
    y: 603.27,
    fill: "#e0e7ff",
    rx: 15.32,
    className: "colore0f6ff svgShape"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 323.38,
    height: 31.26,
    x: 373.92,
    y: 673.28,
    fill: "#e0e7ff",
    rx: 15.32,
    className: "colore0f6ff svgShape"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 323.38,
    height: 31.26,
    x: 373.92,
    y: 743.28,
    fill: "#e0e7ff",
    rx: 15.32,
    className: "colore0f6ff svgShape"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 323.38,
    height: 31.26,
    x: 373.92,
    y: 813.28,
    fill: "#e0e7ff",
    rx: 15.32,
    className: "colore0f6ff svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d6fe3",
    d: "M731 1154.14h-32.55V721.65a16.27 16.27 0 0 1 16.27-16.28A16.28 16.28 0 0 1 731 721.65ZM1225.77 1154.14h-32.56V721.65a16.28 16.28 0 0 1 16.28-16.28 16.28 16.28 0 0 1 16.28 16.28Z",
    className: "color4da2e3 svgShape"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#365bd9",
    d: "M1088.4 475.45c-12.27 26-51.1 291.45-51.1 291.45l-124.5-2.74-41.5-287.45s29.81 3.66 57.59 12.71c.86.28 1.73.56 2.58.86 1.15.39 2.3.79 3.45 1.21 8.46 22 24 82.52 42.94 83.65s37.85-83.37 37.85-83.37 1.77-.65 4.86-1.71l3.07-1c13.62-4.52 42.16-13.01 64.76-13.61Z",
    className: "colord93636 svgShape"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#6889f7",
    d: "M1030.25 726.88c1.15 18.62 17.71 33.09 23.42 29.28s-7.05-23.6-7.05-23.6ZM921 726.88c-1.14 18.62-17.7 33.09-23.41 29.28s7-23.6 7-23.6Z",
    className: "colorf79068 svgShape"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#16234f",
    d: "M731 739.24h462.21v9.28H731z",
    className: "color4f1616 svgShape"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#6889f7",
    d: "M958.69 481.57c4.37 16.2-20.52 9.92-23.78 9.92s6.17 91.08 45.85 94.5 47.9-95.65 35-94.22-20.41.12-18.4-13.79-38.67 3.59-38.67 3.59Z",
    className: "colorf79068 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M957.18 475.45s4.87 26.26 23.49 26.26 18.06-35 18.06-35Z",
    className: "colore6e6e6 svgShape"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#6889f7",
    d: "M1010.93 445.08c-6.09 22.11-16.25 46.67-19.89 48.4-6 2.86-11.13 2.57-22 .58-7-1.28-19.4-29.1-25.8-52-3.58-12.8-5.27-24.07-3-28.26a24.21 24.21 0 0 1 3.84-5.29C958.94 393 993.79 397 1008.52 406c3.07 1.88 5.27 4 6.22 6.16 2.36 5.34.13 18.61-3.81 32.92Z",
    className: "colorf79068 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "M1010.93 445.08c-2 .05-3-1.34-1.85-5.31 4-14.14-4.05-32.66-4.05-32.66l3.49-1.16c3.07 1.88 5.27 4 6.22 6.16 2.36 5.39.13 18.66-3.81 32.97Z",
    className: "colorb3b3b3 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "M946.93 441c.77 3.61-1 3.22-3.67 1.13-3.58-12.8-5.27-24.07-3-28.26a24.21 24.21 0 0 1 3.84-5.29l9.67-3.94s-9.13 25.6-6.84 36.36Z",
    className: "colorb3b3b3 svgShape"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#6889f7",
    d: "M1008.46 428.67c9.71-6.57 20.2-2.85 2.68 19.13s-2.68-19.13-2.68-19.13ZM946.69 433.14c-8.28-7.7-14.85-7.42-10.28 4.57s15.42 11.57 15.42 11.57Z",
    className: "colorf79068 svgShape"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#16234f",
    d: "M939.72 415.08c-6.54-9.13-.25-28.93 15.35-33.52 16.56-4.88 30.26-7.42 53.48 5.33 13.14 9.52 6.71 26.83 6.71 26.83s-37.8-29.72-75.54 1.36Z",
    className: "color4f1616 svgShape"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#6889f7",
    d: "M1079.93 476.71c35.52-6.66 74.52 11.42 49.68 94.5s-67.28 157.71-58 158.08 29.31-1.61 30.07 8.67-4.63 26.86-9.17 27.63-4.15 3-12.14 3.42-12.19 2.29-16 0-16-20.77-16-20.77H1067s-.28-6.85-10-8.07-30.27.29-26.56-21.69 33.88-238.84 49.49-241.77ZM871.3 476.71c-35.52-6.66-74.52 11.42-49.68 94.5s67.28 157.71 58 158.08-35-1.61-35.78 8.67 4.63 26.86 9.17 27.63 4.15 3 12.15 3.42 17.89 2.29 21.7 0 16-20.77 16-20.77h-18.62s.29-6.85 10-8.07 30.26.29 26.55-21.69-33.88-238.84-49.49-241.77Z",
    className: "colorf79068 svgShape"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d6fe3",
    d: "M906.82 994s90.31 25.78 137.61-2.57-68.8-169.33-68.8-169.33Z",
    className: "color4da2e3 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#cccccc",
    d: "M906.82 994s90.31 25.78 137.61-2.57-68.8-169.33-68.8-169.33Z",
    className: "colorcccccc svgShape"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d6fe3",
    d: "M972.2 989.15c3.73 28.06 28.83 64.54 53.06 65.58s21.93-15.33 13.18-28.65-41.12-49.87-41.12-49.87l-10-8.29s-.66 21.99-15.12 21.23ZM961.34 1003c-3.74 28.06-28.84 64.54-53.06 65.58s-21.94-15.32-13.19-28.65 41.12-49.87 41.12-49.87l10-8.29s.66 22.04 15.13 21.23Z",
    className: "color4da2e3 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "M972.2 989.15c3.73 28.06 28.83 64.54 53.06 65.58s21.93-15.33 13.18-28.65-41.12-49.87-41.12-49.87l-10-8.29s-.66 21.99-15.12 21.23Z",
    className: "colorb3b3b3 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "M961.34 1003c-3.74 28.06-28.84 64.54-53.06 65.58s-21.94-15.32-13.19-28.65 41.12-49.87 41.12-49.87l10-8.29s.66 22.04 15.13 21.23Z",
    className: "colorb3b3b3 svgShape"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d6fe3",
    d: "M912.81 764.16s-60.18 194.72-41.51 213 72.72 28 80 8.56 22.65-152 22.65-152 1.14 154.87 27.41 162.86 66.24-12 64.53-28-28.55-201.69-28.55-201.69Z",
    className: "color4da2e3 svgShape"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1013.11 573.64c-24.41 37.25-51.92 14.65-59.66 5.18s-21.9-32.05-24.56-89.4c.86.28 1.73.56 2.58.86 0 0 2.57 96.26 48.38 99.41s50.52-82.33 40.72-99.63l3.07-1s13.89 47.33-10.53 84.58Z",
    className: "colorffffff svgShape"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#4264d6",
    d: "M1986.91 1500.16H113.09a8.15 8.15 0 0 1-5.81-13.88l40.58-41.22 13-13.25 41.2-41.85h1692.21l42.78 41.85 13.54 13.25 42 41.12a8.15 8.15 0 0 1-5.68 13.98Z",
    className: "colord66742 svgShape"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1950.59 1445.06H147.86l13.05-13.25h1776.14l13.54 13.25z",
    className: "colorffffff svgShape"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1042.86 1431.81h14.29v68.35h-14.29zM530.78 1389.96l-26.24 53.1h-15.1l26.23-53.1h15.11zM1549.68 1443.06h-15.09l-26.05-53.1h15.09l26.05 53.1zM962.2 1481.76v-1.51a3.44 3.44 0 0 0-.2-1.25 2.56 2.56 0 0 0-.89-1.12 5.33 5.33 0 0 0-1.88-.82 13.34 13.34 0 0 0-3.15-.31 9.64 9.64 0 0 0-4.14.79c-1.09.52-1.63 1.16-1.63 1.92s.49 1.32 1.48 1.79a11 11 0 0 0 3.66.92l-2.65 5.08a34.7 34.7 0 0 1-6.12-1.1 15.61 15.61 0 0 1-4.09-1.76 7.1 7.1 0 0 1-2.3-2.26 5 5 0 0 1-.75-2.63 4.92 4.92 0 0 1 .9-2.79 7.48 7.48 0 0 1 2.81-2.36 18 18 0 0 1 4.79-1.62 34.21 34.21 0 0 1 6.87-.6 28.22 28.22 0 0 1 7.87 1c2.19.63 3.59 1.56 4.21 2.77h.24a3.27 3.27 0 0 1 1.48-1.74 11.69 11.69 0 0 1 2.88-1.28 24.33 24.33 0 0 1 3.9-.8 37.52 37.52 0 0 1 4.6-.28 36.21 36.21 0 0 1 7.26.64 19.92 19.92 0 0 1 5.18 1.69 8.33 8.33 0 0 1 3.08 2.49 5.17 5.17 0 0 1 1 3q0 2.92-3.44 5t-10.84 2.79l-2.88-4.87a14.64 14.64 0 0 0 4.68-1 2.4 2.4 0 0 0 1.71-2.23c0-1-.66-1.75-2-2.23a15.24 15.24 0 0 0-5.11-.73 13.14 13.14 0 0 0-3.63.39 4.49 4.49 0 0 0-1.91 1 2.47 2.47 0 0 0-.74 1.39 9.89 9.89 0 0 0-.12 1.54v1.07ZM968.05 1469.17q-4.92 0-10-.36a62.55 62.55 0 0 1-9.2-1.26 22.56 22.56 0 0 1-6.74-2.48 4.37 4.37 0 0 1 0-8 22.84 22.84 0 0 1 6.74-2.48 65.36 65.36 0 0 1 9.2-1.26q5.07-.35 10-.35t10 .35a65.15 65.15 0 0 1 9.2 1.26 22.84 22.84 0 0 1 6.74 2.48 4.37 4.37 0 0 1 0 8 22.56 22.56 0 0 1-6.74 2.48 62.36 62.36 0 0 1-9.2 1.26q-5.05.36-10 .36Zm0-4.62c1.45 0 3.19 0 5.22-.08s4-.19 5.85-.42a22 22 0 0 0 4.75-1q1.95-.69 2-2c0-.82-.65-1.47-2-1.94a20.75 20.75 0 0 0-4.75-1.05q-2.8-.35-5.85-.42c-2-.05-3.77-.07-5.22-.07s-3.2 0-5.23.07-4 .19-5.85.42a21.1 21.1 0 0 0-4.76 1.05c-1.29.47-1.94 1.12-1.94 1.94s.65 1.49 1.94 2a22.33 22.33 0 0 0 4.76 1q2.81.35 5.85.42c2.03.05 3.77.08 5.23.08ZM1379.29 303.27h158.62a4.74 4.74 0 0 0 4.63-5.79c-2.84-12.36-14.3-40.18-49.7-32.57-9.14-55.58-80.14-38.07-76.71 8.19-35-8.43-40.76 14.41-41.57 25a4.75 4.75 0 0 0 4.73 5.17ZM1700.8 678.79h124.67a3.72 3.72 0 0 0 3.64-4.55c-2.23-9.71-11.23-31.59-39.06-25.6-7.18-43.69-63-29.92-60.3 6.43-27.52-6.62-32 11.33-32.67 19.69a3.73 3.73 0 0 0 3.72 4.03ZM612.53 620.69h158.62a4.74 4.74 0 0 0 4.63-5.79c-2.84-12.35-14.3-40.18-49.71-32.57-9.13-55.58-80.13-38.06-76.71 8.19-35-8.42-40.75 14.42-41.57 25.05a4.75 4.75 0 0 0 4.74 5.12Z",
    className: "colorffffff svgShape"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#597fff",
    d: "m448.24 578.87-65.94 10.75-23.5-123.71 65.94-10.75 23.5 123.71z",
    className: "colorffbf59 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m448.24 578.87-65.94 10.75-23.5-123.71 65.94-10.75 23.5 123.71z",
    className: "colore6e6e6 svgShape"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#003aff",
    d: "M482.85 394.41a10.44 10.44 0 0 1-2.42-20.59c17.77-4.25 90.09-60.57 92.12-122.8 1.72-52.69-38.19-112.24-50.6-129.43L421.29 138l5.09 26.78a10.44 10.44 0 0 1-20.51 3.9l-7.08-37.31a10.44 10.44 0 0 1 8.57-12.25L524.85 100a10.45 10.45 0 0 1 9.89 3.84c2.48 3.17 60.94 78.33 58.67 147.88-1.3 39.73-25 74-44.75 95.81-21 23.26-47.68 42.86-63.38 46.61a10.68 10.68 0 0 1-2.43.27ZM276 427.83c-16.89 0-46.75-9.64-73.18-23.83s-61.26-38.82-77.05-75.58c-27.77-64.66-.49-153.91.68-157.68a10.44 10.44 0 0 1 8.29-7.19l117.47-19.15a10.43 10.43 0 0 1 11.93 8.36l7.09 37.31a10.43 10.43 0 1 1-20.5 3.89l-5.19-27.32-100.89 16.44c-5.4 20.56-20.57 88.57.28 137.11 25 58.13 114.14 88.29 132.47 86.71a10.44 10.44 0 0 1 1.85 20.79c-1.02.09-2.12.14-3.25.14Z",
    className: "colorffcc00 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#003aff",
    d: "M482.85 394.41a10.44 10.44 0 0 1-2.42-20.59c17.77-4.25 90.09-60.57 92.12-122.8 1.72-52.69-38.19-112.24-50.6-129.43L421.29 138l5.09 26.78a10.44 10.44 0 0 1-20.51 3.9l-7.08-37.31a10.44 10.44 0 0 1 8.57-12.25L524.85 100a10.45 10.45 0 0 1 9.89 3.84c2.48 3.17 60.94 78.33 58.67 147.88-1.3 39.73-25 74-44.75 95.81-21 23.26-47.68 42.86-63.38 46.61a10.68 10.68 0 0 1-2.43.27Z",
    className: "colorffcc00 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#003aff",
    d: "M276 427.83c-16.89 0-46.75-9.64-73.18-23.83s-61.26-38.82-77.05-75.58c-27.77-64.66-.49-153.91.68-157.68a10.44 10.44 0 0 1 8.29-7.19l117.47-19.15a10.43 10.43 0 0 1 11.93 8.36l7.09 37.31a10.43 10.43 0 1 1-20.5 3.89l-5.19-27.32-100.89 16.44c-5.4 20.56-20.57 88.57.28 137.11 25 58.13 114.14 88.29 132.47 86.71a10.44 10.44 0 0 1 1.85 20.79c-1.02.09-2.12.14-3.25.14Z",
    className: "colorffcc00 svgShape"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#597fff",
    d: "M501 241.46c17 89.62-22.6 235.38-103.16 248.5S225 371.67 208 282.06s13.92-98 128.21-116.61C451.81 146.6 484 151.85 501 241.46ZM491.51 588.52l-145.4 23.69c-8.68 1.42-17.17-4.72-18.86-13.62A15.78 15.78 0 0 1 340 579.82l145.4-23.7c8.68-1.41 17.17 4.72 18.86 13.63a15.79 15.79 0 0 1-12.75 18.77Z",
    className: "colorffbf59 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m491.51 588.52-145.4 23.69c-8.68 1.42-17.17-4.72-18.86-13.62A15.78 15.78 0 0 1 340 579.82l145.4-23.7c8.68-1.41 17.17 4.72 18.86 13.63a15.79 15.79 0 0 1-12.75 18.77Z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#f2f2f2",
    className: "colorf2f2f2 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.47,
    cy: 298.04,
    rx: 20.02,
    ry: 86.4,
    transform: "rotate(-14.71 278.4 297.98)",
    style: {
      mixBlendMode: "screen"
    },
    fill: "#808080",
    className: "color808080 svgShape"
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#00196d",
    d: "M294.09 1409c-8.28 3.28-30.69 8.91-46.86 9a40.32 40.32 0 0 1-10.95-1.19c-14.58-4.16-29.16-6.77-35.93-19.79s-4.69-122.38 0-133.83c4.42-10.82 29.67-24.26 46.88-27a37.22 37.22 0 0 1 5.72-.5c16.66 0 37 .4 45.3 5.08s6.25 164.14-4.16 168.23Z",
    className: "color404a70 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#cccccc",
    d: "M247.23 1418a40.32 40.32 0 0 1-10.95-1.19c-14.58-4.16-29.16-6.77-35.93-19.79s-4.69-122.38 0-133.83c4.42-10.82 29.67-24.26 46.88-27s13.04 99.17 0 181.81Z",
    className: "colorcccccc svgShape"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#00196d",
    d: "M820.07 1333h-23.93a6.09 6.09 0 0 1-6.09-6.08 6.09 6.09 0 0 1 6.09-6.09h23.93a6.09 6.09 0 0 1 6.09 6.09 6.09 6.09 0 0 1-6.09 6.08Z",
    className: "color404a70 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#cccccc",
    d: "M820.07 1333h-23.93a6.09 6.09 0 0 1-6.09-6.08 6.09 6.09 0 0 1 6.09-6.09h23.93a6.09 6.09 0 0 1 6.09 6.09 6.09 6.09 0 0 1-6.09 6.08Z",
    className: "colorcccccc svgShape"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#00196d",
    d: "M803.33 1409c-8.27 3.28-30.68 8.91-46.85 9a40.27 40.27 0 0 1-11-1.19c-14.59-4.16-29.17-6.77-35.94-19.79s-4.68-122.38 0-133.83c4.43-10.82 29.68-24.26 46.88-27a37.09 37.09 0 0 1 5.71-.5c16.67 0 37 .4 45.31 5.08s6.31 164.14-4.11 168.23Z",
    className: "color404a70 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#cccccc",
    d: "M756.48 1418a40.27 40.27 0 0 1-11-1.19c-14.59-4.16-29.17-6.77-35.94-19.79s-4.68-122.38 0-133.83c4.43-10.82 29.68-24.26 46.88-27s13.09 99.17.06 181.81Z",
    className: "colorcccccc svgShape"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#00196d",
    d: "M718.26 1333h-419a6.08 6.08 0 0 1-6.08-6.08 6.08 6.08 0 0 1 6.08-6.09h419a6.09 6.09 0 0 1 6.09 6.09 6.09 6.09 0 0 1-6.09 6.08ZM216.48 1333h-23.93a6.09 6.09 0 0 1-6.09-6.08 6.09 6.09 0 0 1 6.09-6.09h23.93a6.09 6.09 0 0 1 6.09 6.09 6.09 6.09 0 0 1-6.09 6.08Z",
    className: "color404a70 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#cccccc",
    d: "m262.43 1417.36-1-.25c20-81.38 2.52-179.79 2.34-180.78l1-.18c.23.98 17.76 99.61-2.34 181.21Z",
    className: "colorcccccc svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#cccccc",
    d: "m282.53 1412.84-1-.16c12.76-82.39.13-174.84 0-175.77l1-.14c.13.92 12.78 93.53 0 176.07Z",
    className: "colorcccccc svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#cccccc",
    d: "m772 1416.89-1-.24c20.05-81.39 2.52-179.8 2.34-180.78l1-.19c.14.99 17.71 99.61-2.34 181.21Z",
    className: "colorcccccc svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#cccccc",
    d: "m791.93 1412.84-1-.16c12.77-82.38.13-174.84 0-175.77l1-.14c.13.92 12.79 93.53 0 176.07Z",
    className: "colorcccccc svgShape"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#365bd9",
    d: "M1254.49 1145.15s-19.17 12.56-52.57 7.09-22.89 10.31-70.82 11.59-56.29-14.81-56.6-20 31.24-2.57 58.45-19.63 52.27-47.66 57.84-58.61a60.84 60.84 0 0 0 5-13.89 5 5 0 0 1 8.34-2.56 27.22 27.22 0 0 1 7.8 16.13v.1a4.72 4.72 0 0 0 .26 1 5 5 0 0 0 1.57 2.21c14.28 11.64 25.58 12.45 32.11 8.68a4.92 4.92 0 0 1 7.33 3c1.64 7 2.81 13.33 3.63 19.08 4.6 32.56-2.34 45.81-2.34 45.81Z",
    className: "colord93636 svgShape"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m1125.69 1158.65-9.74-15.39a1.91 1.91 0 0 1 .79-2.76l21.92-9.87a1.74 1.74 0 0 1 1.19-.09l18 5.07a1.83 1.83 0 0 0 2.23-2.21l-2.15-10.25a1.91 1.91 0 0 1 .72-1.93l34.41-25.63a1.74 1.74 0 0 1 1.82-.17l59.36 29.5a1.93 1.93 0 0 1 .86 2.49l-5.42 12.19a1.78 1.78 0 0 1-2.48.87l-51.09-28a1.73 1.73 0 0 0-1.82.08l-16.92 11.34a1.9 1.9 0 0 0-.77 2.05l6 23.79a1.89 1.89 0 0 1-1.11 2.23l-12.9 5.1a1.77 1.77 0 0 1-1.49-.1l-27.22-15.17a1.75 1.75 0 0 0-1.36-.14l-5.06 1.56a1.9 1.9 0 0 0-.94 2.92l7.45 10.41a1.88 1.88 0 0 1-1.44 3h-11.33a1.78 1.78 0 0 1-1.51-.89Z",
    className: "colorffffff svgShape"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1074.5 1143.87s-.19-7.59 8.87-.9 24.91 17.91 51 16.49 45.27-17.53 71.25-17.53 41.44-1 45.46-9.33 5.34-16.11 7.31-13.53 6.3 27.37-9.16 33.49-49.79-.64-60 .65-25.36 11.91-64 10.94-48.88-8.69-50.73-20.28Z",
    className: "colorffffff svgShape"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#00196d",
    d: "M1169.23 1166.75c-1.21 0-2.42-.06-3.64-.18a.47.47 0 0 1-.42-.52.45.45 0 0 1 .52-.43c12.91 1.29 25.69-4.63 29.06-13.49 2.55-6.7-.66-13.73-9-19.8a105.12 105.12 0 0 1-21.53-20.94.48.48 0 0 1-.4.09l-9.65-2.32v9.41a.47.47 0 0 1-.65.43l-8.08-3.27a.47.47 0 1 1 .35-.87l7.44 3v-9.3a.47.47 0 0 1 .58-.46l9.65 2.32v-.06c-6.48-8.75-10.54-17.57-10.77-24.5-.15-4.43 1.24-7.89 4.13-10.3 12.54-10.45 32.25 6 33.09 6.76a.5.5 0 0 1 .16.43.49.49 0 0 1-.28.37l-17 7.3 1.61 12.17a.47.47 0 0 1-.63.5l-9.42-3.45v10.29a104.23 104.23 0 0 0 21.92 21.64c11.81 8.56 10.94 16.76 9.37 20.89-3.19 8.4-14.39 14.29-26.41 14.29Zm-2.68-93.64a13.91 13.91 0 0 0-9.17 3.17c-2.66 2.22-3.94 5.43-3.8 9.55.22 6.35 3.93 14.56 9.83 22.8V1099a.46.46 0 0 1 .2-.39.44.44 0 0 1 .43 0l9.32 3.41-1.55-11.74a.48.48 0 0 1 .28-.5l16.55-7.13c-2.54-2.09-12.64-9.54-22.09-9.54Z",
    className: "color404a70 svgShape"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1256.83 1099.37c-33 3.58-43-26.84-44.64-33a5 5 0 0 0 1.57 2.21c14.28 11.64 25.58 12.45 32.11 8.68a4.92 4.92 0 0 1 7.33 3c1.64 7.02 2.8 13.36 3.63 19.11Z",
    className: "colorffffff svgShape"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1332.53 1133.34a34.62 34.62 0 1 0-59.09 0Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#00196d",
    d: "M1346.66 1016.94a63.51 63.51 0 1 0-116.27 0c-23.11 8.6-36.59 31.06-28.26 57.33l15.32 41.42a52.21 52.21 0 0 0 49.77 36.43h42.61a52.2 52.2 0 0 0 49.76-36.43l15.32-41.42c8.33-26.27-5.15-48.73-28.25-57.33Zm-58.14-67.51a41.93 41.93 0 0 1 35.79 63.77h-71.57a41.93 41.93 0 0 1 35.78-63.77Z",
    className: "color404a70 svgShape"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#6889f7",
    d: "M1821.35 644c-19.7 19.17-76.23 51.06-97.64 60.49s-115.63 32-115.63 32 1.69 60.9 6.64 61.66 73.47-43 110-59 88.89-70.81 95.17-70.31 23-2.59 24.94-6.4-3.81-4.57-9.9-4-9.33-1-2.85-5.33a24.55 24.55 0 0 1 8.12-3.12c7.47 1.81 9.61 4 11.17 3.56s2.58-2.93-3.18-4.82c4.55-.46 9-.56 12.06-.56 7.23 0 14.37-5.14 19.79-9.24s-38.99-14.07-58.69 5.07Z",
    className: "colorf79068 svgShape"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#16234f",
    d: "M1493.23 728.62c-22.11 3.92-52.84-15.45-51.17-53.36s43.09-47.42 66.8-45.42c7.68.5 7.85-6 7.85-6s15 26-6.51 32.06c-3.71-2.17-5.18-4.17-11.53-.83S1464.11 679.61 1473 699s20.23 29.62 20.23 29.62Z",
    className: "color4f1616 svgShape"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#6889f7",
    d: "M1526.59 785.05c-19.6-14.84-16.94-24.74-16.94-24.74s4.95-22.08-11-35.59 37.69-3.81 37.69-3.81c.29 2.06.58 4.05.87 5.94.63 4.14 1.25 7.87 2 11.1 2.18 9.3 5.53 14.55 13.48 13.79 11.97-1.14-6.5 48.16-26.1 33.31Z",
    className: "colorf79068 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M1539.19 738c-19.37 1-29.45-4.52-29.45-4.52l6.35-8.36s10.17.64 21.08 1.78c.63 4.1 1.25 7.82 2.02 11.1Z",
    className: "colore6e6e6 svgShape"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#6889f7",
    d: "M1504.85 650s48.85 37 44.09 71.85c-2.26 13.57-42.58 17.33-60.62 3.8-10.77 3.26-26.55-3.76-17-11.77-10.52-9.77-11.78-38.58 7.26-49.35s26.27-14.53 26.27-14.53Z",
    className: "colorf79068 svgShape"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d6fe3",
    d: "m1508.73 482.9-23.39 48.53-69.27 101.24-113.2 165.45-166.32 228 153.52-239.61 111.77-163.38 69.11-101 36.05-40.35c1.06-1.16 2.4-.28 1.73 1.12Z",
    className: "color4da2e3 svgShape"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#6889f7",
    d: "M1449.21 806.66c-10.85 12.85-17.42 25.13-22.84 25.41s-79.66-52.54-80.23-60.24-6.57-16.66-14.28-15c-6 1.33-11.25 6-12.68 17.41-.85 2.56-11.3-.18-5.16 13.1 2.57 5.28 15.84-1.72 23.27 10.13s82.35 86 98.62 86 55.68-35.12 55.68-35.12Z",
    className: "colorf79068 svgShape"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#6889f7",
    d: "M1312.05 780.92c-9-.38-16.92 2.57-14.17 5.59s17.74 4.25 20.18 2.88-.06-8.21-6.01-8.47Z",
    className: "colorf79068 svgShape"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#6889f7",
    d: "M1301.52 770.71s11.82 14.62 16.16 12.45 1.13-7 1.13-7 5.23.81 6.06-2.8-1.25-5.23-1.25-5.23a3.49 3.49 0 0 0 4.22-2.28c1.21-3.14-9.58-7.68-7.84-16.76s-11.94 1.85-9.22 7.73c-4.61 1.82-6.4 5.59-5.07 7.93-3.99.76-5.59 4.3-4.19 5.96ZM1297.88 786.51c-3.14-2.31-2.85-11.83-1.14-12.78s2.26 5.85 5.37 8.21-4.23 4.57-4.23 4.57Z",
    className: "colorf79068 svgShape"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#6889f7",
    d: "M1321.65 757s3.78 2 11.63-.3c1.08 7.51-10 10.29-10.13 10s-1.5-9.7-1.5-9.7Z",
    className: "colorf79068 svgShape"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m1508.73 482.9-23.39 48.53-69.27 101.24-14.23-9.54 69.11-101 36.05-40.35c1.06-1.16 2.4-.28 1.73 1.12Z",
    className: "colorffffff svgShape"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#6889f7",
    d: "M1498.08 1082.35c0 29 2.24 39.81-13.75 49s-60 62.81-93.08 161.6c-4.57 13.9-11 30.08-11 30.08l13.13 11.8s77.69-95.45 98.25-125.93c14.5-21.49 36-46.79 41.12-57.07s21.86-39.9 24.14-71.88-58.81 2.4-58.81 2.4ZM1591.85 1091s26.68 46 26.68 54-19.26 22.68-28.56 62.65-6.53 114.38-13.54 138.93 18.5-.57 18.5-.57 54-147.33 71.91-197.58c3.65-10.28-17.48-73.78-17.48-73.78l-42.83-15.3Z",
    className: "colorf79068 svgShape"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#365bd9",
    d: "M1655.83 1078.77c-35.79-3.43-68.52 14.46-68.52 14.46l-16.75-54.45-9.9 54.45s-31.6-13.71-65.48-10.66c2.89-60.88 11.22-102.34 20.17-134.59.13-.5.27-1 .42-1.48.36-1.33.73-2.64 1.11-3.94l95.08 6.57s.78 1.84 2.15 5.14c.2.49.43 1 .66 1.6 8.35 20.26 32.9 81.74 41.06 122.9Z",
    className: "colord93636 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M1655.83 1078.77c-35.79-3.43-68.52 14.46-68.52 14.46l-1.57-5.1-.88-2.83-14.3-46.52-8.12 44.65-.44 2.57-1.31 7.22s-31.6-13.71-65.48-10.66q.16-3.54.37-7c0-.85.09-1.69.13-2.51 3.27-55.74 11.19-94.55 19.67-125.09.13-.5.27-1 .42-1.48.36-1.33.73-2.64 1.11-3.94l95.08 6.57s.78 1.84 2.15 5.14c.2.49.43 1 .66 1.6 7.72 18.74 29.31 72.76 39 113.32l.68 2.94c.45 2.29.93 4.5 1.35 6.66Z",
    className: "colore6e6e6 svgShape"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#365bd9",
    d: "M1641.94 786.38c-1.71 1.15-12 11.82-12 11.82s2.57 20.17-8.85 73-9.14 77.94-9.14 77.94-52 12.57-95.08-6.57c3.38-26-14.64-66.95-25.13-80.92l-.16-.22c-1.86-2.44-3.47-4-4.67-4.49-6 4-10.78 7.35-10.78 7.35s-10.42-21.47-33.66-49.1c0 0 25-41.3 44.44-51.32 10.56-5.45 20.87-6 23.86-4.3s16.4 17.42 27.24 9.29 7-18.86 6.06-19.9 23.78-13.08 85.38-17.66c15.06 19.4 14.2 53.95 12.49 55.08Z",
    className: "colord93636 svgShape"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#16234f",
    d: "M1471.29 713.84s8.85 4.67 13.36 4.34-5.68-3.34-12-15.2-9.06-16-4.28-28.37-13.25-11.7-13.25-11.7l2.82 36.57 9.37 14.86Z",
    className: "color4f1616 svgShape"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#365bd9",
    d: "M1454.05 1390.69a6.63 6.63 0 0 1-.37 2.14s-49.1 0-59.76-1.9-33.31-55.2-32.36-59.58a7.43 7.43 0 0 1 1.6-2.66c4.89-6 19.13-16.62 20.32-14.1 0 0 4.29 13 16.88 11.53 0 12.66 18.68 40.06 38.1 48.06 14.07 5.82 15.74 12.99 15.59 16.51ZM1663.43 1384.81c.17 7.3-9.43 5.74-32.06 5.74h-70a3.6 3.6 0 0 1-3.53-4.34c.09-.44.18-.91.29-1.4 3.1-14.66 11.93-52.08 20.32-47.94a17.43 17.43 0 0 0 19.77.28c14.1 7.37 28.16 22.88 35.58 27.44s28.47 10.55 29.6 19.11a8.92 8.92 0 0 1 .03 1.11Z",
    className: "colord93636 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M1615.62 761.24a85.41 85.41 0 0 1 14.33 37c1.57-1.63 4.22-4.34 4.22-4.34a84.47 84.47 0 0 0-18.55-32.66Z",
    className: "colore6e6e6 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M1516.88 942.56c3.38-26-14.64-66.95-25.13-80.92l-.16-.22c-1.86-2.44-3.47-4-4.67-4.49l11.78-8.39s26.76 60.12 18.18 94.02Z",
    className: "colore6e6e6 svgShape"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1614.77 955.87s-48.29 10.4-99.42-7.89c.13-.5.27-1 .42-1.48 0 0 51.92 14 98.34 7.77.2.49.43 1.03.66 1.6ZM1495.68 1073.07c16.19-.16 40.77 1.52 66.76 10.36l-.44 2.57c-14.6-3.92-40-9.65-66.42-10.43ZM1654.41 1072.13c-24.07 1.63-35.41-3.22-68.67 16l-.88-2.83c24.34-14 39.1-16.08 68.87-16.11ZM1525 827.1l1.34-13.72a1.8 1.8 0 0 1 1.1-1.59l14.82-5a1.19 1.19 0 0 1 1.33.44l3.51 4.45c.82 1 2.28.35 2.43-1.16l.45-4.63a1.82 1.82 0 0 1 1.09-1.59l16.18-5.61c1.09-.38 2 .89 1.65 2.25l-.13.47c-.5 1.81 1.26 3.12 2.33 1.73l5.45-7.1a1.46 1.46 0 0 1 .8-.54l12.77-3c1.18-.28 2 1.29 1.41 2.62l-2.39 5.1c-.64 1.35.25 2.94 1.44 2.61l5.8-1.59a1.78 1.78 0 0 0 1.16-1.61l.59-6a1.82 1.82 0 0 1 1.13-1.6l18.41-5.81c.89-.28 1.72.54 1.7 1.69l-.61 47a1.86 1.86 0 0 1-1.11 1.78l-25.65 8.65a1.26 1.26 0 0 1-1.55-.79l-4.64-10.4a1.27 1.27 0 0 0-1.49-.82l-17.76 5a1.81 1.81 0 0 0-1.17 1.71l-.25 4.69a1.83 1.83 0 0 1-1.12 1.69l-9.28 3a1.11 1.11 0 0 1-.94-.11l-10.72-6.4a1.2 1.2 0 0 0-1-.08l-10.46 4.17a1.76 1.76 0 0 0-1 1.23l-1.55 6.16a1.53 1.53 0 0 1-1.52 1.31l-2.27-.22a1.6 1.6 0 0 1-1.24-1.78l.92-26.46a.71.71 0 0 1 .04-.14Z",
    className: "colorffffff svgShape"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#00196d",
    d: "m1527.91 827.32 1.2-12.29 12.89-4.33 2.91 3.69a3.8 3.8 0 0 0 2.62 1.52c2.39.24 4.57-2 4.87-5.07l.32-3.29 13-4.51a6 6 0 0 0 .59 2 4.16 4.16 0 0 0 3.21 2.41 4.07 4.07 0 0 0 3.57-1.76l5.1-6.64 9.08-2.14-.72 1.53a6.82 6.82 0 0 0-.2 5.26 4.21 4.21 0 0 0 3.38 2.88 3.51 3.51 0 0 0 1.28-.12l5.79-1.59c1.91-.52 3.35-2.52 3.59-5l.46-4.65 15.48-4.88-.56 43.1-23.37 7.89-4.09-9.17a4.14 4.14 0 0 0-3.29-2.62 3.71 3.71 0 0 0-1.28.11l-17.77 5c-2 .55-3.46 2.71-3.59 5.26l-.18 3.23-7.61 2.48-10.24-6.11a3.53 3.53 0 0 0-3.15-.25l-10.41 4.17a5.43 5.43 0 0 0-3 3.81l-.72 2.85Z",
    className: "color404a70 svgShape"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#365bd9",
    d: "m1530.85 827.46.92-9.52 9.28-3.11 1.77 2.25a6.41 6.41 0 0 0 4.39 2.54c4 .39 7.65-3.42 8.15-8.5l.06-.68 8.61-3a6.36 6.36 0 0 0 11.18.77l4.41-5.73 3.41-.81a10.93 10.93 0 0 0 .73 3.81c1.09 2.77 3.21 4.56 5.67 4.8a5.77 5.77 0 0 0 2.14-.19l5.79-1.59c3.19-.88 5.61-4.21 6-8.3l.19-2 9.83-3.1-.46 35.55-19 6.39-3-6.79a7 7 0 0 0-5.5-4.39 6 6 0 0 0-2.15.19l-17.76 5c-3.32.92-5.8 4.55-6 8.8v.43l-4.41 1.43-9.3-5.55a5.83 5.83 0 0 0-2.47-.82 6 6 0 0 0-2.8.41l-10.08 4Z",
    className: "colord93636 svgShape"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e4eba",
    d: "M1407 1364.77a1.17 1.17 0 0 1-1-.68 1.15 1.15 0 0 1 .23-1.27l6.08-6.15h-10.42a1.15 1.15 0 0 1-.73-2l5.63-4.66h-10.06a1.14 1.14 0 0 1-.71-2l6.31-5h-9.23a1.13 1.13 0 0 1-1.08-.78 1.14 1.14 0 0 1 .39-1.28l6.52-4.93h-7.36a1.15 1.15 0 0 1 0-2.29h10.78a1.15 1.15 0 0 1 .69 2.06l-6.52 4.93h9.1a1.14 1.14 0 0 1 .71 2l-6.32 5h10a1.15 1.15 0 0 1 .73 2l-5.63 4.66h10a1.13 1.13 0 0 1 1.06.7 1.15 1.15 0 0 1-.24 1.25l-5.94 6 12-.56a1.13 1.13 0 0 1 1.2 1.09 1.15 1.15 0 0 1-1.09 1.2l-15 .7ZM1629.32 1370.23a1.31 1.31 0 0 1-.43-.08 1.15 1.15 0 0 1-.71-1.06v-6.43l-6.76 1.06a1.15 1.15 0 0 1-1-.32 1.17 1.17 0 0 1-.31-1l.92-5.55-7.85 1.62a1.15 1.15 0 0 1-1-.32 1.13 1.13 0 0 1-.3-1.05l1.48-6.7-7.14 1.84a1.15 1.15 0 0 1-1.21-.43 1.13 1.13 0 0 1-.06-1.27l2.9-4.82-8.32-.71a1.15 1.15 0 0 1-.66-2c.32-.28 8-6.83 17.35-5.43 1.64.24 3.33.49 3.26 1.88 0 1.08-.1 2-14.78 2.71a2 2 0 0 1-.33 0c-.55.29-1.06.59-1.52.86l7 .6a1.14 1.14 0 0 1 .89 1.73l-2.41 4 6.25-1.6a1.14 1.14 0 0 1 1.08.29 1.12 1.12 0 0 1 .32 1.07l-1.5 6.79 7.75-1.61a1.15 1.15 0 0 1 1.36 1.31l-.93 5.64 6.51-1a1.13 1.13 0 0 1 .93.26 1.17 1.17 0 0 1 .4.87v5l2.47-2.5a1.15 1.15 0 1 1 1.63 1.61l-4.43 4.49a1.17 1.17 0 0 1-.85.25Z",
    className: "colorba2e2e svgShape"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e4eba",
    d: "M1454.05 1390.69a6.63 6.63 0 0 1-.37 2.14s-49.1 0-59.76-1.9-33.31-55.2-32.36-59.58a7.43 7.43 0 0 1 1.6-2.66s22.25 53.77 30.56 56.92 59.37 5.05 60.33 5.08ZM1663.43 1384.81c.17 7.3-9.43 5.74-32.06 5.74h-70a3.6 3.6 0 0 1-3.53-4.34c.09-.44.18-.91.29-1.4Z",
    className: "colorba2e2e svgShape"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d6fe3",
    d: "m1866.55 1082.31 10.07 64.7a12.41 12.41 0 0 1-10.36 14.17L1707 1186a12.42 12.42 0 0 1-14.18-10.36l-10.07-64.69a12.4 12.4 0 0 1 10.35-14.17l159.27-24.78a12.41 12.41 0 0 1 14.18 10.31Z",
    className: "color4da2e3 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m1866.55 1082.31 10.07 64.7a12.41 12.41 0 0 1-10.36 14.17L1707 1186a12.42 12.42 0 0 1-14.18-10.36l-10.07-64.69a12.4 12.4 0 0 1 10.35-14.17l159.27-24.78a12.41 12.41 0 0 1 14.18 10.31Z",
    className: "colore6e6e6 svgShape"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d6fe3",
    d: "m1866.55 1082.31 10.07 64.7a7.14 7.14 0 0 1-7.13 9.75l-159.31 24.8a12.4 12.4 0 0 1-14.17-10.35l-10.08-64.69a7.13 7.13 0 0 1 7.12-9.75l159.32-24.77a12.41 12.41 0 0 1 14.18 10.31ZM1779.66 1172.12h9.92v215.54h-9.92z",
    className: "color4da2e3 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M1779.66 1172.12h9.92v215.54h-9.92z",
    className: "colore6e6e6 svgShape"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3c4ff",
    d: "M1723.25 1141.79h-.16a7.11 7.11 0 0 1-3 1.13 9.72 9.72 0 0 1-3.18 0 8.16 8.16 0 0 1-3.1-1.19 8.56 8.56 0 0 1-2.52-2.5 9.71 9.71 0 0 1-1.44-3.92 10.36 10.36 0 0 1 .15-4.26 8.83 8.83 0 0 1 1.65-3.33 9.07 9.07 0 0 1 2.81-2.32 11.52 11.52 0 0 1 3.7-1.22 11 11 0 0 1 3.89.06 9.39 9.39 0 0 1 3.39 1.37 9 9 0 0 1 3.95 6.24 13.47 13.47 0 0 1 .17 2.45 11.82 11.82 0 0 1-.26 2.17 16.55 16.55 0 0 1-.6 2.1c-.25.7-.54 1.42-.86 2.15l-5.44 12.54-4.56.71Zm2.24-9.22a6.72 6.72 0 0 0-.8-2.32 5.28 5.28 0 0 0-1.5-1.68 5.51 5.51 0 0 0-2.07-.94 6.87 6.87 0 0 0-4.83.75 5.76 5.76 0 0 0-1.69 1.52 5.37 5.37 0 0 0-.91 2.07 6.42 6.42 0 0 0-.06 2.44 6.59 6.59 0 0 0 .8 2.31 5.21 5.21 0 0 0 1.5 1.69 5.62 5.62 0 0 0 2.06.94 6.88 6.88 0 0 0 4.84-.75 5.89 5.89 0 0 0 1.69-1.52 5.53 5.53 0 0 0 .91-2.07 6.63 6.63 0 0 0 .06-2.44ZM1745.12 1150.2a11.43 11.43 0 0 1-3.74 0 8.55 8.55 0 0 1-3.23-1.25 8.18 8.18 0 0 1-2.4-2.43 9 9 0 0 1-1.29-3.52 6.91 6.91 0 0 1 0-2.53 7.64 7.64 0 0 1 .83-2.21 6.91 6.91 0 0 1 1.48-1.8 7.73 7.73 0 0 1 2-1.28v-.12a5.3 5.3 0 0 1-1.73-.48 5.66 5.66 0 0 1-1.64-1.11 7 7 0 0 1-1.33-1.79 8 8 0 0 1-.81-2.58 6.39 6.39 0 0 1 .21-3 6.8 6.8 0 0 1 1.46-2.52 8.52 8.52 0 0 1 2.44-1.84 10.17 10.17 0 0 1 3.13-1 10.3 10.3 0 0 1 3.28 0 8.63 8.63 0 0 1 2.89 1 7 7 0 0 1 2.16 2 6.42 6.42 0 0 1 1.12 2.82 7.89 7.89 0 0 1 0 2.7 7.05 7.05 0 0 1-.72 2.12 6.1 6.1 0 0 1-1.23 1.55 5.23 5.23 0 0 1-1.5 1v.12a8.05 8.05 0 0 1 2.3.61 7.1 7.1 0 0 1 2 1.27 7.66 7.66 0 0 1 1.46 1.86 7 7 0 0 1 .81 2.39 8.94 8.94 0 0 1-.16 3.74 8.39 8.39 0 0 1-1.55 3 8.67 8.67 0 0 1-2.7 2.18 11.53 11.53 0 0 1-3.54 1.1Zm-7.88-21.16a4.9 4.9 0 0 0 .56 1.61 4.55 4.55 0 0 0 1.1 1.29 4.59 4.59 0 0 0 1.55.82 4.43 4.43 0 0 0 2 .1 4.7 4.7 0 0 0 1.9-.69 4.33 4.33 0 0 0 1.23-1.22 4.24 4.24 0 0 0 .63-1.56 5.34 5.34 0 0 0 0-1.74 4.57 4.57 0 0 0-1.74-3.06 4.35 4.35 0 0 0-3.44-.76 4.44 4.44 0 0 0-3 1.74 4.38 4.38 0 0 0-.79 3.43Zm7.36 17.77a5.46 5.46 0 0 0 3.7-2.08 5.15 5.15 0 0 0 .92-4 5.85 5.85 0 0 0-.78-2.21 4.68 4.68 0 0 0-1.44-1.52 5.05 5.05 0 0 0-1.89-.74 6.58 6.58 0 0 0-2.17 0 5.58 5.58 0 0 0-3.67 2.12 5.06 5.06 0 0 0-1 4 5.46 5.46 0 0 0 .79 2.17 4.81 4.81 0 0 0 1.45 1.46 5.41 5.41 0 0 0 1.89.76 6.14 6.14 0 0 0 2.2.04ZM1762.33 1152.48l-3.31.51 1.24-10.35 3.87-.61ZM1780 1137.83l-12.18 1.89-.62-4 8.52-20.08 4.68-.73 2.94 18.88 4-.63.53 3.38-4 .63 1 6.29-3.88.6Zm-2.75-17.67h-.08l-6.49 15.64 8.79-1.37ZM1801.17 1141.47a11.72 11.72 0 0 1-3.74 0 8.56 8.56 0 0 1-3.23-1.26 8.18 8.18 0 0 1-2.4-2.43 8.87 8.87 0 0 1-1.29-3.52 6.85 6.85 0 0 1 0-2.52 7.32 7.32 0 0 1 .83-2.22 6.91 6.91 0 0 1 1.48-1.8 8.13 8.13 0 0 1 2-1.28v-.12a5.3 5.3 0 0 1-1.73-.48 5.66 5.66 0 0 1-1.64-1.11 7 7 0 0 1-1.33-1.79 7.9 7.9 0 0 1-.81-2.58 6.53 6.53 0 0 1 .2-3 7 7 0 0 1 1.47-2.52 8.71 8.71 0 0 1 2.44-1.84 10.66 10.66 0 0 1 6.41-1 8.64 8.64 0 0 1 2.89 1 7 7 0 0 1 2.16 2 6.52 6.52 0 0 1 1.12 2.82 8.21 8.21 0 0 1 0 2.71 6.82 6.82 0 0 1-.73 2.11 6.07 6.07 0 0 1-1.22 1.56 5.46 5.46 0 0 1-1.5 1v.13a7.74 7.74 0 0 1 2.3.61 6.85 6.85 0 0 1 2 1.26 7.66 7.66 0 0 1 1.46 1.86 7 7 0 0 1 .81 2.39 8.93 8.93 0 0 1-.16 3.74 8.31 8.31 0 0 1-1.55 3.05 8.54 8.54 0 0 1-2.7 2.18 11.53 11.53 0 0 1-3.54 1.05Zm-7.88-21.15a4.93 4.93 0 0 0 .56 1.6 4.4 4.4 0 0 0 4.62 2.21 4.47 4.47 0 0 0 1.9-.69 4.21 4.21 0 0 0 1.23-1.22 4.42 4.42 0 0 0 .63-1.56 5.34 5.34 0 0 0 0-1.74 4.52 4.52 0 0 0-1.74-3.05 4.35 4.35 0 0 0-3.44-.77 4.44 4.44 0 0 0-3 1.74 4.35 4.35 0 0 0-.76 3.48Zm7.36 17.76a5.46 5.46 0 0 0 3.7-2.08 5.19 5.19 0 0 0 .92-4 6.09 6.09 0 0 0-.78-2.21 4.78 4.78 0 0 0-1.43-1.47 5.12 5.12 0 0 0-1.89-.74 6.58 6.58 0 0 0-2.17 0 5.63 5.63 0 0 0-3.68 2.12 5.09 5.09 0 0 0-.94 4 5.46 5.46 0 0 0 .79 2.17 5 5 0 0 0 1.45 1.47 5.31 5.31 0 0 0 1.89.75 5.91 5.91 0 0 0 2.14-.01ZM1823.28 1118l3.39-.53.46 3h.08a3.25 3.25 0 0 1 .47-1.1 6.77 6.77 0 0 1 1.12-1.36 8 8 0 0 1 1.71-1.21 6.79 6.79 0 0 1 2.29-.75 6.88 6.88 0 0 1 3.73.33 6.62 6.62 0 0 1 2.79 2.29 6.22 6.22 0 0 1 2.21-3.07 7.37 7.37 0 0 1 3.29-1.42 8 8 0 0 1 3.74.16 5.82 5.82 0 0 1 2.52 1.57 7.42 7.42 0 0 1 1.53 2.53 16.07 16.07 0 0 1 .79 3.07l1.73 11.13-3.63.57-1.66-10.65a14.88 14.88 0 0 0-.47-2.07 4.6 4.6 0 0 0-.86-1.68 3.31 3.31 0 0 0-1.44-1 4.36 4.36 0 0 0-2.21-.13 4.31 4.31 0 0 0-3.5 2.2 7.23 7.23 0 0 0-.48 4.33l1.63 10.44-3.63.56-1.56-10a20.59 20.59 0 0 0-.53-2.48 5.93 5.93 0 0 0-.87-1.86 3 3 0 0 0-1.41-1.1 4.26 4.26 0 0 0-2.19-.14 4.8 4.8 0 0 0-1.81.68 4.41 4.41 0 0 0-1.42 1.4 5.61 5.61 0 0 0-.78 2.12 8.89 8.89 0 0 0 0 2.86l1.55 9.92-3.63.57Z",
    className: "colorb3e7ff svgShape"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#16234f",
    d: "m1751.49 1395.22 1.2-4.87c.8-3.17 1.89-7.84 3.42-13.75.72-3 1.65-6.21 2.69-9.75l3.33-11.45c1.13-4.12 2.56-8.41 4-13s3-9.31 4.77-14.26 3.69-10 5.65-15.36l1.48-4 1.64-4c1.1-2.7 2.22-5.45 3.36-8.23s2.3-5.6 3.48-8.45 2.51-5.68 3.79-8.56 2.58-5.8 3.9-8.75 2.8-5.83 4.21-8.79c2.86-5.91 5.73-11.94 8.91-17.9q2.33-4.5 4.69-9c1.56-3 3.32-6 5-9l5.07-9q2.65-4.47 5.31-9t5.38-9l5.59-8.88c7.5-11.84 15.49-23.34 23.48-34.57s16.39-21.89 24.72-32 16.68-19.7 24.74-28.62 16-17 23.55-24.35c3.73-3.69 7.38-7.14 10.87-10.41s6.86-6.29 10.07-9.09c6.37-5.65 12.07-10.41 16.81-14.27s8.6-6.72 11.21-8.68 4.08-2.93 4.08-2.93-1.36 1.09-3.85 3.22-6.06 5.31-10.57 9.4-9.91 9.15-15.93 15.13-12.71 12.82-19.88 20.38l-5.44 5.84-5.56 6.14c-3.8 4.14-7.58 8.55-11.54 13-7.75 9.08-15.82 18.74-23.85 29-4.08 5.07-8 10.39-12.07 15.72-2 2.66-4 5.41-6 8.15l-6 8.25c-7.85 11.17-15.7 22.63-23.07 34.39l-5.59 8.77-5.38 8.88-5.32 8.88-5.08 8.94c-3.43 5.91-6.62 11.89-9.8 17.78s-6.2 11.78-9.14 17.59c-1.45 2.91-3 5.77-4.33 8.66l-4.07 8.57-4 8.39c-1.24 2.8-2.47 5.57-3.69 8.29-4.94 10.88-9.14 21.35-13.14 31q-2.8 7.31-5.35 14c-1.72 4.44-3.37 8.64-4.72 12.65l-3.93 11.21c-1.24 3.46-2.34 6.65-3.22 9.57-1.81 5.83-3.35 10.38-4.34 13.49Z",
    className: "color4f1616 svgShape"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#16234f",
    d: "M1759.49 1327.45a46.37 46.37 0 0 1 24-1.56c-13.32 20.37-32 69.33-32 69.33s2.74-45.22 8-67.77Z",
    className: "color4f1616 svgShape"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1298.58,
    cy: 566.19,
    r: 48.39,
    fill: "#365bd9",
    transform: "rotate(-21.96 1298.567 566.178)",
    className: "colord93636 svgShape"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#365bd9",
    d: "m1217.49 466.8 106 57.91-70.83 26.18s11.12-25.58-47.51-67.74a3 3 0 0 1-.59-4.31c4.13-5.18 7.36-9.13 9.15-11.31a3 3 0 0 1 3.78-.73Z",
    className: "colord93636 svgShape"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#365bd9",
    d: "m1278.5 500.13 3.07-5.53a2 2 0 0 1 3.2-.3l14.15 17Z",
    className: "colord93636 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m1278.5 500.13 3.07-5.53a2 2 0 0 1 3.2-.3l14.15 17Z",
    className: "colore6e6e6 svgShape"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#365bd9",
    d: "m1342.5 586.56 1.17-7.89c.07 1 .31 1 .77 1.08 2.36.37 10.87.44 11.67-5.87s-10.44-8.76-10.44-8.76l.83-5.68s18.14 2.36 15.6 16.6-19.6 10.52-19.6 10.52Z",
    className: "colord93636 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m1342.5 586.56 1.17-7.89c.07 1 .31 1 .77 1.08 2.36.37 10.87.44 11.67-5.87s-10.44-8.76-10.44-8.76l.83-5.68s18.14 2.36 15.6 16.6-19.6 10.52-19.6 10.52Z",
    className: "colore6e6e6 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1298.58,
    cy: 566.19,
    r: 41.45,
    fill: "#e6e6e6",
    transform: "rotate(-71.85 1298.678 566.162)",
    className: "colore6e6e6 svgShape"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d6fe3",
    d: "M1280.25 454.59h1.17v25.47h-1.17z",
    transform: "rotate(-14.44 1280.368 467.216)",
    className: "color4da2e3 svgShape"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d6fe3",
    d: "m1274.81 481.47-12.25-22.33 1.03-.56 12.24 22.33-1.02.56z",
    className: "color4da2e3 svgShape"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d6fe3",
    d: "M1259.86 465.6h1.17v25.46h-1.17z",
    transform: "rotate(-44.02 1260.358 478.333)",
    className: "color4da2e3 svgShape"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#4a73ff",
    d: "m657 353.5 117.2-90.16a6.64 6.64 0 0 1 10 1.91L831 363.4a6.63 6.63 0 0 1-4.67 9.74l-144.2 28.47a6.62 6.62 0 0 1-6.94-3.37l-19.8-36.47a6.62 6.62 0 0 1 1.61-8.27Z",
    className: "colorff8a4a svgShape"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#4a73ff",
    d: "m705.71 392.84 10.55 17.68a4.1 4.1 0 0 0 3.83 2l28.22-2.05a4.11 4.11 0 0 0 3.57-5.5l-6.81-18.88-7 .8 4 10.79a4.12 4.12 0 0 1-3.69 5.53l-13.76.61a4.12 4.12 0 0 1-3.7-2l-6.44-10.5Z",
    className: "colorff8a4a svgShape"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M687.35 363.87 685 351.34a1.65 1.65 0 0 1 .7-1.72l13.89-8.62a1.39 1.39 0 0 1 1.48 0l4.8 2.95a1.49 1.49 0 0 0 2.18-1.71l-.78-4.23a1.65 1.65 0 0 1 .69-1.71l15.04-9.5a1.57 1.57 0 0 1 2.3 1.52v.45a1.52 1.52 0 0 0 2.86.88l3.68-7.83a1.49 1.49 0 0 1 .67-.71l12.29-6.27a1.61 1.61 0 0 1 2.15 1.92l-1.08 5.2a1.61 1.61 0 0 0 2.2 1.9l5.51-3.05a1.63 1.63 0 0 0 .76-1.76l-1-5.51a1.65 1.65 0 0 1 .72-1.74l17.33-10.34a1.52 1.52 0 0 1 2.2 1l12.08 41.83a1.69 1.69 0 0 1-.66 1.9l-24 14.91a1.43 1.43 0 0 1-1.8-.26l-7.58-7.91a1.44 1.44 0 0 0-1.74-.3L733 362.06a1.65 1.65 0 0 0-.74 1.84l1 4.23a1.66 1.66 0 0 1-.69 1.81l-8.71 5.3a1.39 1.39 0 0 1-1 .17l-12.73-2.64a1.37 1.37 0 0 0-1.07.22l-9.56 6.63a1.62 1.62 0 0 0-.67 1.37l.07 5.89a1.55 1.55 0 0 1-1.2 1.6l-2.39.44a1.57 1.57 0 0 1-1.76-1.22l-6.2-23.7Z",
    className: "colorffffff svgShape"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#00196d",
    d: "M690.41 363.24 688.32 352l12.1-7.49 4 2.45a4.32 4.32 0 0 0 3.09.61 4.9 4.9 0 0 0 3.63-5.87l-.56-3 12.13-7.7a5.31 5.31 0 0 0 1.15 1.62 4.61 4.61 0 0 0 3.94 1.23 4.46 4.46 0 0 0 3.19-2.57l3.44-7.32 8.75-4.47-.33 1.57a5.55 5.55 0 0 0 1.22 4.72 4.52 4.52 0 0 0 4.24 1.59 4.09 4.09 0 0 0 1.29-.47l5.51-3a5 5 0 0 0 2.34-5.41l-.79-4.25 14.58-8.7 11.07 38.35-21.86 13.58-6.68-7a4.49 4.49 0 0 0-4.07-1.4 4.25 4.25 0 0 0-1.29.47L731.52 359a5.09 5.09 0 0 0-2.27 5.68l.69 2.91-7.14 4.35-12.16-2.53a4.21 4.21 0 0 0-3.3.68l-9.56 6.63a5 5 0 0 0-2.06 4.22v2.73Z",
    className: "color404a70 svgShape"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#365bd9",
    d: "m693.46 362.53-1.62-8.69 8.68-5.38 2.42 1.49a7.39 7.39 0 0 0 5.19 1c4.21-.79 6.93-5.19 6.07-9.83l-.12-.63 8-5.07a7.58 7.58 0 0 0 6.32 1.82 7.44 7.44 0 0 0 5.36-4.3l3-6.32 3.28-1.68a9.29 9.29 0 0 0 1.78 3.17 7.56 7.56 0 0 0 7.11 2.65 6.76 6.76 0 0 0 2.15-.77l5.51-3a8.45 8.45 0 0 0 3.93-9.06l-.34-1.81 9.25-5.52 9.13 31.62-17.72 11-5-5.16a7.53 7.53 0 0 0-6.82-2.33 7 7 0 0 0-2.16.78l-16.86 9.4a8.52 8.52 0 0 0-3.81 9.5l.09.39-4.13 2.51-11-2.29a7.07 7.07 0 0 0-2.75 0 6.91 6.91 0 0 0-2.77 1.16l-9.25 6.42Z",
    className: "colord93636 svgShape"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d6fe3",
    d: "M1527.17 166.87h198.44a5.55 5.55 0 0 1 5.55 5.55v39.35h-209.54v-39.35a5.55 5.55 0 0 1 5.55-5.55Z",
    transform: "rotate(8.1 1638.848 189.868)",
    className: "color4da2e3 svgShape"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d6fe3",
    d: "m1599.72 376.45-42.46-174.31-37.76-5.38 80.22 179.69zM1726.94 226.32l-127.22 150.13 89.46-155.51",
    className: "color4da2e3 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m1599.72 376.45-42.46-174.31-37.76-5.38 80.22 179.69z",
    className: "colore6e6e6 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m1726.94 226.32-127.22 150.13 89.46-155.51",
    className: "colore6e6e6 svgShape"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1595.3,
    cy: 407.52,
    r: 50.7,
    fill: "#4a73ff",
    transform: "rotate(-45 1595.29 407.52)",
    className: "colorff8a4a svgShape"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1595.3,
    cy: 407.52,
    r: 43.93,
    fill: "#597fff",
    transform: "rotate(-45 1595.29 407.52)",
    className: "colorffbf59 svgShape"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#16234f",
    d: "M394.45 822.05s64.47-81.64 137.05 28.77a2.1 2.1 0 0 1-1.41 3.21c-23.35 3.94-50 14.71-58.09 27.25a2.08 2.08 0 0 1-3.64-.3c-14.73-32.59-35.7-46.88-58.79-35.77-24.05 11.56-15.12-23.16-15.12-23.16Z",
    className: "color4f1616 svgShape"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#16234f",
    d: "M397.75 894.44s27.08-26.88 6.11-61.72S332.92 822.24 328 842c-2.44 8.94 12.66 24.35 12.66 24.35Z",
    className: "color4f1616 svgShape"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#6889f7",
    d: "M427.57 930s-24.75 22-32.88 38.31c-1.89 3.76-2.77 5.77-3.07 6.48.67-1.75 3.95-11.17 1.37-18.69s-6.12-16-10.67-22.68c-2.76-4.08-5.88-7.47-9.33-9.52-2.24-1.32-2.1-3.68-.63-6.49 4.56-8.68 22-21.64 22-21.64 13.55 31.16 33.21 34.23 33.21 34.23Z",
    className: "colorf79068 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M390.6 904.62s-.83 17.31-8.28 28.78c-2.76-4.08-5.88-7.47-9.33-9.52-2.24-1.32-2.1-3.68-.63-6.49Z",
    className: "colore6e6e6 svgShape"
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#6889f7",
    d: "M328.34 853.68c-4 34.53 5.86 77.07 27.44 86.93 10.78 4.63 33.29-19.11 37-41.61 13.56-9.87 11.09-23.74 0-19.42-.62-12.64-12.95-17.57-12.95-17.57ZM501.8 904.22c39.32-12.2 71.18-17 81-14.24s54.92 44.41 74.58 74.24c4.74 7.12 35.59 22.37 34.57 34.23s-30.5 35.6-37.28 32.55-6.78-21.7-7.12-22.72-8.81-5.42-4.75-15.59 7.8-9.49-5.42-18.3-50.17-40-59.66-44.41-49.83 13.56-78.64 15.59 2.72-41.35 2.72-41.35ZM382.82 1032.69c-3.73 25.76-3.39 36.61-8.81 37s-92.2-7.12-96.61-9.83-12.88-25.09-25.76-22.37a26 26 0 0 0-10.51 5.08s-9.15-4.07-13.56-2.37-18.3 25.42 0 48.47c4.75 6.78 40-3.73 55.25-2.37s101.75 26.44 115.62 18.64 33.53-72.2 33.53-72.2ZM681.12 1240c38.13 25.43 49.32 33.56 68.13 52.37s85.42 71.19 151.52 126.61c17.29 18.81 25.93 18.81 25.93 18.81s-13.73-33-29-44.23-38.13-37.63-68.13-84.92c-17.29-28-46.27-38.13-61-54.91s-51.35-63-51.35-63ZM434 1182.52c-27.8 23.39-40 49.15-5.09 72.54s111.86 45.76 161.69 89.15 11.54-14.21 11.54-14.21-81.36-94.57-115.25-105.42c-7.8-2-13.56-5.42 1-12.54s39.66-21.36 39.66-21.36l-81-15.59Z",
    className: "colorf79068 svgShape"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#365bd9",
    d: "M516.38 1106.39s-85 73.52-87.26 80.41c42 0 57.83-4 57.83-4l5.84 26.72s74.43-38.74 97.82-36.7 21.39-72.17 21.39-72.17Z",
    className: "colord93636 svgShape"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m432 1183 56.52-3.36a1.8 1.8 0 0 1 1.87 1.45l5.37 26.94 4.52-2.28-6.16-29.18a1.79 1.79 0 0 0-1.9-1.42l-56.8 4.25Z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M516.38 1106.39s-85 73.52-87.26 80.41c42 0 57.83-4 57.83-4l5.84 26.72s74.43-38.74 97.82-36.7 21.39-72.17 21.39-72.17Z",
    className: "colore6e6e6 svgShape"
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#365bd9",
    d: "M595.7 1083.88s63.55 9.66 87.45 52.37 53.49 78.75 53.49 78.75l-40.33 4.24 3.19 33.11s-102.15-55.63-142.45-104.9c-70.05-85.74 38.65-63.57 38.65-63.57Z",
    className: "colord93636 svgShape"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#365bd9",
    d: "M595.7 1083.88s63.55 9.66 87.45 52.37 53.49 78.75 53.49 78.75l-40.33 4.24 3.19 33.11s-102.15-55.63-142.45-104.9c-70.05-85.74 38.65-63.57 38.65-63.57ZM424.13 927.92C470.36 909 508 902.34 508 902.34s-8.37 23.91 6.88 40.95c-13.74 7.67-31 22.11-31 22.11Z",
    className: "colord93636 svgShape"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M505.38 902.84s-9.52 23.78 7.56 41.55c-1.24.74-2.56 1.55-2.56 1.55s-17.78-16.87-7.47-42.59c1.09-.25 2.47-.51 2.47-.51Z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#000000",
    className: "color000000 svgShape"
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M424.13 927.92C470.36 909 508 902.34 508 902.34s-8.37 23.91 6.88 40.95c-13.74 7.67-31 22.11-31 22.11Z",
    className: "colore6e6e6 svgShape"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#597fff",
    d: "M922.42 843c-48.86-3.09-101.47-17.65-164.64 1.92C638.67 881.85 606.8 957 549.33 986.66c-19.53 10.06-37.81 15.05-53.9 16.71l-5.49-9.6c16.67-2 36.86-8.58 60.65-23 81.76-49.75 87.56-117 213.86-148.05 38.06-8.69 76.15-3.31 113.9-2.36Z",
    className: "colorffbf59 svgShape"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#365bd9",
    d: "M421.26 927.69s46 .94 87 54.15S554 1053 600.78 1085.23s-87.2 23.58-87.2 23.58-24.32-37.48-41.27-46-39.69-6.35-49.17-16.73-41.45-41.49-31.39-71.7 29.51-46.69 29.51-46.69Z",
    className: "colord93636 svgShape"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#597fff",
    d: "M480.59 1066.57s41.81 41.31 120.41-13.29 80.32-122.08 204.52-160.72c54.81-16.06 112.2 9.33 166.16-4.37s84.8-46.19 84.8-46.19l34.26 1.66s-57.47 67.7-110.54 70.67-111.71-24.93-180 .86c-116.66 44-143.92 121-199.49 154.07s-103 21.48-115.89 8.92c-8-7.24-4.23-11.61-4.23-11.61Z",
    className: "colorffbf59 svgShape"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#365bd9",
    d: "M414.18 954.22c-21.5-2.35-31.91 24.9-32.35 85.67 17.59 9.16 43.93 11.5 43.93 11.5s32.65-92.34-11.58-97.17Z",
    className: "colord93636 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414.18 954.22c-21.5-2.35-31.91 24.9-32.35 85.67 17.59 9.16 43.93 11.5 43.93 11.5s32.65-92.34-11.58-97.17Z",
    style: {
      mixBlendMode: "screen"
    },
    fill: "#1a1a1a",
    className: "color1a1a1a svgShape"
  }), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#16234f",
    d: "M339.87 827.86s-26.54-1.64-33.93 29.47c7.39-13.74 18.39-28.07 35.78-24.84s-1.85-4.63-1.85-4.63Z",
    className: "color4f1616 svgShape"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#16234f",
    d: "M340.21 830.64s-20.81-.92-29.13 28c23.58 2.08 71.82 21.11 81.69 21s4.08-32.29 4.08-32.29ZM602.14 1330s27.11-3.73 30.5 3.39 8.82 26.78 23.39 47.12 2 41-5.42 35.25-47.62-61-53.81-66.28-2.8-13.72 2.29-14.73 3.05-4.75 3.05-4.75ZM897.72 1393.53s30.51.84 34.58 12 4.06 25.08 13.22 32.2 34.23 38.31 21.69 42.71-51.52 1.7-42.37-10.84-5.42-25.43-15.93-35.26a62.53 62.53 0 0 1-14.74-20.95s2.2-10.57 10-7.52-6.45-12.34-6.45-12.34Z",
    className: "color4f1616 svgShape"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 40.78,
    height: 33.81,
    x: 280.42,
    y: 1059.66,
    fill: "#ffffff",
    rx: 7.46,
    transform: "rotate(8.2 300.924 1076.944)",
    className: "colorffffff svgShape"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 40.78,
    height: 32.22,
    x: 619.45,
    y: 944.76,
    fill: "#ffffff",
    rx: 5.43,
    transform: "rotate(43.62 639.834 960.861)",
    className: "colorffffff svgShape"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m695.08 1249.87-2.5-34.51a1.2 1.2 0 0 1 1.15-1.29l40.64-1.91-2.69-3.42-41.68 1.16a1.2 1.2 0 0 0-1.17 1.31l2.93 36.75ZM510.71 1104.55s71.87.62 86.38-21.9a12.47 12.47 0 0 0-3.14-2.23s-20.9 19.41-85.57 20.78a16 16 0 0 0 2.33 3.35ZM381.83 1036.34s22.82 10.89 44.73 12.68l1-2.84s-30.34-5.34-45.74-13.49ZM1013.86 343.91h188.67A5.64 5.64 0 0 0 1208 337c-3.38-14.7-17-47.8-59.12-38.74-10.87-66.11-95.31-45.28-91.24 9.74-41.65-10-48.48 17.14-49.45 29.8a5.66 5.66 0 0 0 5.67 6.11ZM1299.05 439.44h151.22c2.9 0 5.06-2.14 4.41-4.39-2.71-9.36-13.63-30.45-47.38-24.68-8.71-42.12-76.39-28.85-73.13 6.2-33.38-6.38-38.85 10.93-39.63 19-.2 2.08 1.87 3.87 4.51 3.87ZM255.63 752.73h127.13c2.44 0 4.26-1.8 3.71-3.69-2.28-7.87-11.46-25.6-39.84-20.75-7.32-35.41-64.22-24.25-61.48 5.22-28.07-5.37-32.66 9.18-33.32 16-.17 1.72 1.58 3.22 3.8 3.22Z",
    className: "colorffffff svgShape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitnessTeacher);
export default __webpack_public_path__ + "static/media/fitness-teacher.660c87af35ea8699a9bfd11f4d01adf4.svg";
export { ForwardRef as ReactComponent };